export const environment = {
  production: true,
  buildId: '2775050583518941',
  configFile: 'config.json',
};
